var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_discount-shape",
    "data-name": "vuesax/bulk/discount-shape",
    transform: "translate(-364 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discount-shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(364 316)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.985,12.635l-1.52-1.52a1.606,1.606,0,0,1,0-2.26l1.52-1.52a1.845,1.845,0,0,0,.47-1.13V4.055a1.6,1.6,0,0,1,1.6-1.6H6.2a1.845,1.845,0,0,0,1.13-.47L8.855.465a1.606,1.606,0,0,1,2.26,0l1.52,1.52a1.845,1.845,0,0,0,1.13.47h2.15a1.6,1.6,0,0,1,1.6,1.6V6.2a1.845,1.845,0,0,0,.47,1.13l1.52,1.52a1.606,1.606,0,0,1,0,2.26l-1.52,1.52a1.845,1.845,0,0,0-.47,1.13v2.15a1.6,1.6,0,0,1-1.6,1.6h-2.15a1.845,1.845,0,0,0-1.13.47l-1.52,1.52a1.606,1.606,0,0,1-2.26,0l-1.52-1.52a1.845,1.845,0,0,0-1.13-.47H4.055a1.6,1.6,0,0,1-1.6-1.6v-2.15A1.8,1.8,0,0,0,1.985,12.635Z",
    transform: "translate(366.005 318.025)",
    fill: "#908fa2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.01,2A1,1,0,1,1,2,1,.994.994,0,0,1,1.01,2Z",
    transform: "translate(377.99 330)",
    fill: "#908fa2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.01,2A1,1,0,1,1,2,1,.994.994,0,0,1,1.01,2Z",
    transform: "translate(372 324)",
    fill: "#908fa2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.747,7.5a.742.742,0,0,1-.53-.22.755.755,0,0,1,0-1.06l6-6a.75.75,0,0,1,1.06,1.06l-6,6A.742.742,0,0,1,.747,7.5Z",
    transform: "translate(372.253 324.252)",
    fill: "#908fa2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.4b338f406ffb4da982decd393bf2be7e.svg";
export { ForwardRef as ReactComponent };